import withRouter from 'Common/withRouter';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { appDispatch } from 'slices';
import { changeLayoutMode } from 'slices/layouts/thunk';
const NonAuthLayout = (props: any) => {
  const dispatch = appDispatch();

  const selectProperties = createSelector(
    (state: any) => state.Layout,
    (layout) => ({
      layoutModeType: layout.layoutModeType,
    })
  );
  const { layoutModeType } = useSelector(selectProperties);
  useEffect(() => {
    if (layoutModeType) {
      dispatch(changeLayoutMode(layoutModeType));
    }
  }, [layoutModeType, dispatch]);

  useEffect(() => {
    document.documentElement.classList.add('light', 'scroll-smooth', 'group');
    return () => {
      document.documentElement.classList.remove(
        'light',
        'scroll-smooth',
        'group'
      );
    };
  }, []);

  return <React.Fragment>{props.children}</React.Fragment>;
};

export default withRouter(NonAuthLayout);
